<mat-card class="mainHeader">

  <div class="dflex">

    <button mat-icon-button class="navbar-toggle-button" fxHide.gt-md (click)="openSidemenu()">
      <!-- <img src="../../../../../assets/images/logo/MiniLogo.png" alt="" > -->
      <!-- <img src="../../../../../assets/images/logo/flogo.svg" width="30" alt="" > -->
      <svg id="logosvg" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 232.7 232.7">
        <defs>
          <style>
            .cls-1 {
              fill: #010101;
            }
          </style>
        </defs>
        <path class="cls-1"
          d="M-315.8,188.25A116.48,116.48,0,0,0-432.15,304.6a115.89,115.89,0,0,0,8.27,43.21h0l.08.18c.73,1.8,1.49,3.59,2.31,5.36a116.46,116.46,0,0,0,6.77,12.52c.83,1.34,1.69,2.65,2.58,4,.69,1.09,1.37,2.12,2,3.09l.05.24c5.34,7.77,17.65,23.14,36.16,31.56a40.67,40.67,0,0,0,13.21,2.2,40.77,40.77,0,0,0,9.5-1.12,40.91,40.91,0,0,0,18.66-9c1-.85,2-1.75,3-2.71a43.3,43.3,0,0,0,5.22-6.3l.11-.16c.29-.42.57-.85.84-1.28A42.56,42.56,0,0,0-317,363.61c0-.15,0-.29,0-.44V340.22h.1v-12h16.55V314.64h-16.55V287.05a20.58,20.58,0,0,1,6.3-14.73,20.69,20.69,0,0,1,11.35-6h0l.34-.06c2.25-.34,15.11-1.69,21.27,10.14h22.47a40.89,40.89,0,0,0-26.28-30.22h0l-.06,0a40.85,40.85,0,0,0-13.65-2.34,41.31,41.31,0,0,0-9.5,1.11,41.55,41.55,0,0,0-21.62,11.69,43.92,43.92,0,0,0-6.17,7.75,42.47,42.47,0,0,0-6.42,22.76c0,.15,0,.29,0,.44v22.95h-.09v4.08h-16.58v13.62h16.58v35.46a20.58,20.58,0,0,1-6.3,14.74c-.39.38-.78.74-1.18,1.09s-.64.53-1,.78l-.22.18a19.63,19.63,0,0,1-2.49,1.62h0a21.14,21.14,0,0,1-2.2,1.06h0a14.08,14.08,0,0,1-8.14,1.44,17.15,17.15,0,0,1-4.65-.93c-5.06-1.59-11.39-5.41-18.55-13.64h0c-1.51-1.53-2.95-3.1-4.28-4.68A102,102,0,0,1-403.44,340a94.57,94.57,0,0,1-6.87-35.36,94.61,94.61,0,0,1,94.51-94.51,94.61,94.61,0,0,1,94.51,94.51,94.62,94.62,0,0,1-94.51,94.51c-1.37,0-2.78,0-4.21-.1l-6.27,5.27a50.79,50.79,0,0,1-22.85,11c-.48.12-1,.22-1.47.32a116.12,116.12,0,0,0,34.8,5.3A116.47,116.47,0,0,0-199.45,304.6,116.48,116.48,0,0,0-315.8,188.25Z"
          transform="translate(432.15 -188.25)" />
      </svg>

    </button>

    <div class="toolbar-separator"></div>

    <!-- <div *ngIf="modulename != '' && modulename != 'Form' && modulename != 'Calendar' && modulename != 'Facility'" class="pagetitle">
      <h1>{{modulename}}</h1>
    </div> -->

    <!-- <div *ngIf="modulename == 'Form' && projectName == ''" class="pagetitle">
      <h1>{{modulename}}</h1>
    </div> -->

    <div class="pagetitle">
      <h1>{{modulename}}</h1>
    </div>

    <!-- <div *ngIf="modulename == 'Form' && projectName != ''" class="pagetitle">
      <h1>{{modulename}}</h1>
    </div> -->

    <!-- <div *ngIf="modulename == 'Calendar'" class="pagetitle">    
      <h1>Doctor</h1>  
      <div class="tabLook"> -->
    <!-- <a href="javascript:void(0)" class="pagetitle" [routerLink]="'/calendar'" routerLinkActive="active"  [routerLinkActiveOptions]="{exact:
          true}" ><h1>Calendar</h1></a>
        <a href="javascript:void(0)" class="pagetitle" [routerLink]="'/calendar/cases'" routerLinkActive="active" ><h1>Cases</h1></a>
        <a href="javascript:void(0)" class="pagetitle" [routerLink]="'/calendar/scheduleList'"  routerLinkActive="active"  ><h1>Scheduler List</h1></a>
        <a href="javascript:void(0)" class="pagetitle" [routerLink]="'/calendar/SchedulerCalendar'"  routerLinkActive="active"  ><h1>Scheduler Calendar</h1></a>         -->
    <!-- </div>
    </div> -->


    <!-- <div *ngIf="modulename == 'Facility'" class="pagetitle">
      <h1>Facility</h1> 
      <div class="tabLook"> -->
    <!-- <a href="javascript:void(0)" class="pagetitle" [routerLink]="'/facility'" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"  ><h1>Calendar</h1></a>
        <a href="javascript:void(0)" class="pagetitle" [routerLink]="'/facility/cases'" routerLinkActive="active" > <h1>Cases</h1></a>
        <a href="javascript:void(0)" class="pagetitle" [routerLink]="'/facility/scheduleList'"  routerLinkActive="active"  ><h1>Scheduler List</h1></a>
        <a href="javascript:void(0)" class="pagetitle" [routerLink]="'/facility/SchedulerCalendar'"  routerLinkActive="active"  ><h1>Scheduler Calendar</h1></a>        
        
        <a href="javascript:void(0)" class="pagetitle" [routerLink]="'/facility/surgeryList'"  routerLinkActive="active"  ><h1  style="font-size: 14px;">Surgery List</h1></a>        
        <a href="javascript:void(0)" class="pagetitle" [routerLink]="'/facility/waitingroom'"  routerLinkActive="active"  ><h1  style="font-size: 14px;">Waiting Room</h1></a>         -->
    <!-- </div>
    </div> -->



    <div class="saveName" *ngIf="(edashboard == 'true' || modulename == 'Template') && !htmlFormLinkActivated">
      <mat-icon *ngIf="type == '1'" class="type">drafts</mat-icon>
      <mat-icon *ngIf="type == '2'">description</mat-icon>
      <input matInput [(ngModel)]="projectName" [ngClass]="{'bounce' : projectNameExist}"
        (blur)="onChange($event.target.value)" type="text" placeholder="Project Name..." autoSizeInput
        [extraWidth]="10" />
    </div>

    <div class="saveName" *ngIf="htmlFormLinkActivated">
      <input matInput [ngClass]="{'bounce' : projectNameExist}" type="text" placeholder="Form Name..." autoSizeInput
        [extraWidth]="10" [(ngModel)]="currentFormName" (ngModelChange)="ChangeFormName($event)" />
    </div>



    <!-- <div *ngIf="modulename == ''" class="pagetitle">
      <h1>Dashboard</h1>
    </div> -->



  </div>

  <div class="officeLogo" *ngIf="officeLogo!=''">
    <img  width="" src="{{ officeLogo }}" />
    <!-- <img  width="" src="data:image/png;base64,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" /> -->
  </div>


  <div class="dflex" fxFlex="0 1 auto" fxLayout="row" fxLayoutAlign="start center">

    <button mat-mini-fab  color="primary" [matMenuTriggerFor]="quickMenu" class="user-button add_miniFab">
      <mat-icon>add</mat-icon>
    </button>

    <mat-menu class="customPanel" #quickMenu="matMenu" [overlapTrigger]="false" xPosition="before">

      <button mat-menu-item (click)="createNewTask()">
        <mat-icon>task_alt</mat-icon> <span>Add Task</span>
      </button>

      <button mat-menu-item (click)="taskTemplateShow()">
        <mat-icon>task_alt</mat-icon> <span>Send Tasklist</span>
      </button>
      <button mat-menu-item (click)="FlowtricsAIChat(AIChatDialog)">
        <mat-icon>chat</mat-icon> <span>AI Assistant</span>
      </button>
      <div *ngFor="let folder of menuModulesList; index as i">
        <button mat-menu-item *ngIf="folder.mainModuleName == 'Forms'" (click)="QuickForm()">
          <!-- <mat-icon>create</mat-icon> <span>Create PDF {{folder.orgModuleName}}</span> -->
          <mat-icon>create</mat-icon> <span>Start eSignature Project</span>
        </button>
        <button *ngIf="folder.mainModuleName == 'Core'" mat-menu-item (click)="addNew(folder)">
          <mat-icon>dns</mat-icon> <span>Add {{folder.orgModuleName}}</span>
        </button>
        <button *ngIf="folder.mainModuleName == 'Contact'" mat-menu-item (click)="addNew(folder)">
          <mat-icon>contacts</mat-icon> <span>Add {{folder.orgModuleName}}</span>
        </button>
        <button *ngIf="folder.mainModuleName == 'Company'" mat-menu-item (click)="addNew(folder)">
          <mat-icon>group_work</mat-icon> <span>Add {{folder.orgModuleName}}</span>
        </button>

        <!-- <button *ngIf="folder.folderName == 'Task'" mat-menu-item (click)="addNew(folder)">
          <mat-icon>list_alt</mat-icon> <span>Add {{folder.folderName}}</span>
        </button>  -->
      </div>
      <!-- <button  mat-menu-item (click)="taskTemplateShow()">
          <mat-icon>group_work</mat-icon> <span>Send Tasklist</span>
      </button>   -->


    </mat-menu>


    <div class="toolbar-separator"></div>

    <button mat-button (click)="userOtherLink(); preventCloseOnClick()" class="user-button userOnly">
      <div fxLayout="row" fxLayoutAlign="center center" class="dflex">
        <div class="picture">
          <ng-container *ngIf="ImagePathURL">
            <ng-container *ngIf="ImagePathURL.substring(0, 4) == 'http'; else showName">
              <img src="{{ ImagePathURL }}" />
            </ng-container>

            <ng-template #showName>
              <span class="shortName">
                {{ getShortName(FullName) }}</span>
            </ng-template>
          </ng-container>

          <div class="s-name" *ngIf="!ImagePathURL">
            {{ getShortName(FullName) }}
          </div>


        </div>
        <span class="username " fxHide fxShow.gt-sm>
          <h1>{{ FullName}}</h1>
          <span class="officename" >{{currentOffice}}</span>
        </span>
        <mat-icon  class="s-16 userarrow" fxHide.xs>keyboard_arrow_down</mat-icon>
      </div>
    </button>

    <mat-card class="customPanel" (click)="preventCloseOnClick()" *ngIf="showOtherLinks">

      <form [formGroup]="userDetailform">
        <div class="office">
          <select formControlName="selectedOffice" (change)="onOfficeddlStatusChange($event)">
            <option *ngFor="let f of officeList" [value]="f.officeID"> {{ f.officeName }}</option>
          </select>
        </div>

        <!-- <mat-form-field appearance="fill" class="Status_drop">
        <mat-select formControlName="selectedOffice" (selectionChange)="onOfficeddlStatusChange($event)" >
          <mat-option *ngFor="let f of officeList" [value]="f.officeID">
            {{ f.officeName }}
          </mat-option>
        </mat-select>
      </mat-form-field> -->
      </form>
      <button mat-menu-item (click)="linkclick('My Profile')">
        <mat-icon>account_circle</mat-icon>
        <span> My Profile</span>
      </button>

      <button mat-menu-item (click)="linkclick('Training')">
        <mat-icon>video_library</mat-icon>
        <span> Training</span>
      </button>

      <button mat-menu-item *ngIf="currentTheme == 'dark-theme'" (click)="changeTheme('light-theme')">
        <mat-icon>wb_sunny</mat-icon> <span>Light Theme</span>
      </button>

      <button mat-menu-item *ngIf="currentTheme == 'light-theme'" (click)="changeTheme('dark-theme')">
        <mat-icon>brightness_2</mat-icon> <span>Dark Theme</span>
      </button>

      <a mat-menu-item target="blank" href="https://mysupport.flowtrics.com/">
        <mat-icon>support</mat-icon> <span>Support</span>
      </a>     

      <!-- <a mat-menu-item target="blank" (click)="openVedioLink(showVedio)">
        <mat-icon>smart_display</mat-icon> <span>Support</span>
      </a> -->

      <a mat-menu-item target="blank" href="https://app.flowtrics.com/request/tickettask?token=Mpbs8rtV5IySrg%2FvzzDAKNw%2FFIyamBni1QnoS5aaIP718BG5nm86iAHw72K%2BqAfd1R%2B47wG2iZ4pqu7GAvNEGTobBr%2FMXpCznyszlLg7I%2F9DXc05DFl3wft5qn80wRGT3M1M06sq4WE4rY2j7797m56JQBWUY63i594i877OBar09QWkr%2BAe2WSDSHkXDeazksMs8%2BN6%2F7SQlnGLPtgNxHskotWKgU5ZvZLgIgVyWio70iTQbt%2BnJMT6xdjqayZohGxn1%2FUvWUuOx0SjU%2BJF%2FA%3D%3D">
        <mat-icon>confirmation_number</mat-icon> <span>Ticket</span>
      </a>

      <!-- <a mat-menu-item target="blank" href="https://support.flowtrics.com/submit_ticket">
        <mat-icon>confirmation_number</mat-icon> <span>Ticket</span>
      </a> -->

      <button mat-menu-item class="" (click)="logOutUser()">
        <mat-icon>exit_to_app</mat-icon>
        <span>Logout</span>
      </button>

    </mat-card>

    <div class="toolbar-separator"></div>

    <a href="https://mysupport.flowtrics.com/" target="blank" mat-icon-button class="user-button">
      <mat-icon matBadgeColor="warn" class="secondary-text">support</mat-icon>
    </a>

     <a mat-icon-button (click)="openVedioLinkNew()">
        <mat-icon>smart_display</mat-icon>      
     </a>

     <!-- <a *ngIf="mainModuleNames == 'Referral Management'" mat-icon-button (click)="openVedioLink('Referral Management',showVedio)">
        <mat-icon>smart_display</mat-icon>      
     </a>

     <a *ngIf="mainModuleNames == 'Medicaid Approval'" mat-icon-button (click)="openVedioLink('Medicaid Approval',showVedio)">
        <mat-icon>smart_display</mat-icon>      
     </a>

     <a *ngIf="mainModuleNames == 'SNF Dashboard'" mat-icon-button (click)="openVedioLink('SNF Dashboard',showVedio)">
        <mat-icon>smart_display</mat-icon>      
     </a>

      <a *ngIf="mainModuleNames == 'Core'" mat-icon-button (click)="openVedioLink('Core',showVedio)">
        <mat-icon>smart_display</mat-icon>      
     </a> -->

    <div class="toolbar-separator"></div>

    <button mat-icon-button [matMenuTriggerFor]="notification" class="user-button" (click)="ShowNotificationList()">
      <mat-icon *ngIf="UnreadNotification==0" matBadgeColor="warn" class="secondary-text">notifications_none</mat-icon>
      <mat-icon *ngIf="UnreadNotification > 0" matBadge={{UnreadNotification}} matBadgeColor="warn"
        class="secondary-text">notifications_none</mat-icon>
    </button>

    <mat-menu (click)="ShowNotificationList()" class="customPanelNotificaiton" #notification="matMenu"
      [overlapTrigger]="false" xPosition="before">
      <mat-card class="allnoti">
        <div class="headings">
          <h4>Notifications</h4>
          <a *ngIf="UnreadNotification > 0" (click)="Markallasread()">Mark all as read </a>
        </div>
        <div class="notifications">
          <ul *ngFor="let noti of NotificationList">
            <li class="notirep" (click)="MarkPerticularRead(noti)" *ngIf="noti.isRead">
              <div class="userpic" *ngIf="noti.imageUrl">
                <img [src]="noti.imageUrl" alt="" />
              </div>
              <div class="userpic" *ngIf="!noti.imageUrl">
                <span class="shortName">{{getShortName(noti.senderName)}}</span>
              </div>
              <div class="text">
                <p><b>{{noti.senderName |titlecase}}</b> {{noti.message}}</p>
                <span>{{noti.createdOn| DayAgo}} </span>
              </div>
            </li>

            <li class="notirep unread" (click)="MarkPerticularRead(noti)" *ngIf="!noti.isRead">
              <div class="userpic" *ngIf="noti.imageUrl">
                <img [src]="noti.imageUrl" alt="" />
              </div>
              <div class="userpic" *ngIf="!noti.imageUrl">
                <span class="shortName">{{getShortName(noti.senderName)}}</span>
              </div>
              <div class="text">
                <p><b>{{noti.senderName |titlecase}}</b> {{noti.message}}</p>
                <span>{{noti.createdOn| DayAgo}} </span>
              </div>
            </li>

          </ul>
        </div>


        <div class="all">
          <span [routerLink]="'/notifications'">See all notifications</span>
        </div>
      </mat-card>
    </mat-menu>

    <!-- <div *ngIf="ShowChat" class="toolbar-separator "></div>

    <button *ngIf="ShowChat" mat-icon-button (click)="showChat(show)" class="chat-panel-toggle-button "
      aria-label="Toggle chat panel">
      <mat-icon matBadgeColor="warn" class="secondary-text">chat</mat-icon>
    </button> -->

    <!-- <button mat-icon-button class="chat-panel-toggle-button" [routerLink]="'/chat'">
      <mat-icon  matBadgeColor="warn" class="secondary-text">chat</mat-icon>     
    </button> -->


  </div>
</mat-card>


<app-addnew *ngIf="showAddContact" (closeAdd)="getClose($event)" [modulename]='Module'
  [ngClass]="{'open': showAddContact}"></app-addnew>

<ng-template #AIChatDialog>

  <!-- <h2 mat-dialog-title>
    <span class="groupIcon"><mat-icon>description</mat-icon></span>
    Flowtrics AI Chat

    <div style="margin-left: 50px;">
      <mat-form-field style="width:180px;">
        <mat-label>Search</mat-label>
        <input matInput type="text" [(ngModel)]="searchText" placeholder="Search" (keyup.enter)="search()">
      </mat-form-field>
      <button mat-icon-button (click)="search()">
        <mat-icon>search</mat-icon>
      </button>
    </div>
   
  </h2> -->


  <div class="chatGpt">

    <div class="chatList">

      <h2>Flowtrics AI</h2>

      <div class="search" >
        <mat-form-field >
          <mat-label>Search</mat-label>
          <input matInput type="text" [(ngModel)]="searchText" placeholder="Search" (keyup.enter)="search()" (input)="Clearsearch()">
        </mat-form-field>
        <button mat-icon-button (click)="search()">
          <mat-icon>search</mat-icon>
        </button>
      </div>

      <div class="history">
        <mat-checkbox color="primary" class="example-margin" (change)="clickHistoryToggle($event.checked)"
        [checked]="isHistoryToggleActivate">
        {{chatHistoryMsg}}
      </mat-checkbox>
      </div>

      <div class="cListHolder" id="chatDiv1" (scroll)="scrollHandler($event)">
        <div class="cList" *ngFor="let chathHistory of aiDataHistory">
          <mat-icon class="chatIcon">chat_bubble</mat-icon>
          <span (click)="addToCurrentChat(chathHistory)">{{chathHistory.title}}</span>
          <!-- title
          tmpId
          question
          answer -->
          <!-- <button class="del" mat-icon-button ><mat-icon>delete</mat-icon></button> -->
        </div>
      </div>
      

      <!-- <div *ngFor="let data of aiSearchHistory; let index = index">
        <mat-expansion-panel hideToggle
          [ngStyle]="index % 2 == 0 ? {'background-color':'#E5E7E9'} : {'background-color': '#D5DBDB'}">
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{data.title}}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-card class="question-example-card">
            <mat-card-header>
              <div mat-card-avatar style="background-color: white;">
                <div style="margin: 11px 0px 0px 11px;">
                  {{getShortName(this.currentUser.Name)}}
                </div>
              </div>
              <mat-card-subtitle style="text-align: justify;color:black;">{{data.question}}</mat-card-subtitle>
            </mat-card-header>
          </mat-card>

          <mat-card class="response-example-card">
            <mat-card-header>
              <div mat-card-avatar class="response-example-header-image"></div>
              <mat-card-subtitle
                style="max-width: 700px;text-align: justify;white-space: pre-line;color:black;">{{data.answer}}</mat-card-subtitle>
              <div class="fill"></div>
              <button mat-raised-button color="primary" style="width:80px;height:40px;margin-right:5px;"
                (click)="copyHistoryResponse(data.tmpId)">Copy</button><br />
            </mat-card-header>
          </mat-card>
        </mat-expansion-panel>
      </div> -->

    </div>

    <div class="currentChat">
      <button class="closeAi" mat-icon-button (click)="close()">
        <mat-icon>close</mat-icon>
      </button>
      <div id="chatDiv" (scroll)="scrollHandler($event)">

        <div class="loader">
          <img src="../../../../../assets/images/ring.gif"  *ngIf="isLoading" />
        </div>
        <!-- Search UI -->

        <!-- AI Response -->

        <div class="ourQuestion" *ngFor="let data of aiData; let index = index">


          <div class="query">
            <div class="user_pic">{{getShortName(this.currentUser.Name)}}</div>
           
            <div class="answer">
              <p>{{data.question}}</p>
            </div>
          </div>

          <div class="query response" *ngIf="data.answer.length>0">
            <div  class="flowAi user_pic"></div>
              <div class="answer">
                <p>{{data.answer}}</p>
              </div>

            <div class="answerAction">
              <button mat-icon-button color="basic"
                (click)="copyResponse(data.tmpId)"><mat-icon>content_copy</mat-icon></button>
              <button mat-icon-button color="basic"
                (click)="openSaveDialog(AISaveDialog,data.tmpId,data.question)"><mat-icon>save_as</mat-icon></button>
            </div>

          </div>

        </div>



      </div>



      <div class="askQuestion">
        <input [(ngModel)]="chatMsg" (keyup.enter)="getAPIResponse()" placeholder="Send a message" />
        <button mat-icon-button color="primary" (click)="getAPIResponse()"><mat-icon>send</mat-icon></button>
      </div>
    </div>
  </div>



  <!-- <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
   
    <button mat-flat-button color="basic" (click)="close()"> Cancel</button>
  </mat-dialog-actions> -->



  
</ng-template>

<ng-template #AISaveDialog>
  <h2 mat-dialog-title>
    <span class="groupIcon"><mat-icon>save</mat-icon></span>
    Flowtrics Save Chat
    <button mat-icon-button (click)="closeSaveDialog()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
  <mat-dialog-content>
    <mat-form-field class="example-full-width">
      <mat-label>Enter the Title for the AI Request/Response</mat-label>
      <input matInput type="text" [(ngModel)]="titleName" placeholder="Enter the Title for the AI Request/Response">
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-flat-button color="basic" (click)="closeSaveDialog()"> Cancel</button>
    <button mat-flat-button color="success" disabled="{{titleName.trim().length==0}}" (click)="saveResponse()">
      Save</button>
  </mat-dialog-actions>
</ng-template>


<ng-container *ngIf="showCreateTask">
  <div class="createTask setMaxH" cdkDrag cdkDragBoundary=".right">
    <app-addtask (getCloseCreateTask)="getCloseCreateTask()"
       [taskId]="taskId" [moduleName]="moduleNames" [taskListID]="taskListID">
    </app-addtask>
  </div>
</ng-container>

<ng-template #showVedio>
  <h2 mat-dialog-title>   
    <button mat-icon-button (click)="closeVedio()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">
    <ng-container>
  <div class="video-container">
    <iframe
      [src]="safeSrcVedio"
      frameborder="0"
      webkitallowfullscreen
      mozallowfullscreen
      allowfullscreen>
    </iframe>
  </div>
</ng-container>
  </mat-dialog-content>
 <mat-dialog-actions align="start" fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-button color="basic" (click)="closeVedio()">Cancel</button>
  </mat-dialog-actions>
</ng-template>